import { FetchInit, NormalizedFetchInit } from '../types';

/**
 * Normalize the `FetchInit` object.
 *
 * It makes sure that middlewares can expect an object that always has the
 * same shape, and as a consequence remove the need to check for the presence
 * of some attributes (eg. `FetchInit#headers`).
 */
export function normalizeInit(init: FetchInit): NormalizedFetchInit {
  return {
    method: init.body ? 'POST' : 'GET',
    ...init,
    headers: new Headers(init.headers),
  };
}
